import React, { useState } from 'react';
import {
  Checkbox,
  CloseIcon,
  ISelectValue,
  Select,
  SelectArrowDownIcon,
  TextInput,
  Typography,
} from '@room-match/shared-ui-components';
import {
  ActionsContainer,
  CheckboxContainer,
  CloseButton,
  Content,
  CustomButton,
  CustomDialog,
  CustomDialogContent,
  Header,
  TwoColumn,
} from './AddPaymentMethodModal.styles';
import { InputLabel } from '@material-ui/core';

const paymentMethodList: ISelectValue[] = [
  {
    key: 'Credit Card',
    value: 'Credit Card',
  },
  {
    key: 'PayPal',
    value: 'PayPal',
  },
];

type Props = {
  open: boolean;
  onClose: (instance: boolean) => void;
};
const AddPaymentMethodModal: React.FC<Props> = ({ open, onClose }) => {
  const [paymentMethod, setPaymentMethod] = useState<any>('Credit Card');

  return (
    <CustomDialog
      open={open}
      onClose={() => onClose(false)}
      maxWidth="sm"
      fullWidth
      aria-labelledby="simple-dialog-title"
    >
      <CustomDialogContent>
        <CloseButton>
          <CloseIcon style={{ width: '14px' }} onClick={() => onClose(false)} />
        </CloseButton>
        <Header>
          <Typography fontSize={24}>Add Payment Method</Typography>
        </Header>
        <Content>
          <div>
            <InputLabel id="preferredMethodOfContact">Payment Method</InputLabel>
            <Select
              fullWidth
              variant="outlined"
              data={paymentMethodList}
              IconComponent={SelectArrowDownIcon}
              name="payment_method"
              placeHolder="Select Payment Method"
              value={paymentMethod}
              onChange={(e, k) => setPaymentMethod(e.target.value)}
            />
          </div>
          {paymentMethod === 'Credit Card' ? (
            <>
              <div>
                <TextInput label={'Card Number'} placeholder="Enter Card Number…" />
              </div>
              <TwoColumn>
                <div>
                  <TextInput label={'Expiry Date'} placeholder="" />
                </div>
                <div>
                  <TextInput label={'CVV'} placeholder="" />
                </div>
              </TwoColumn>
              <div>
                <TextInput label={'Card Holder Name'} placeholder="Enter Holder Name…" />
              </div>
            </>
          ) : (
            <div>
              <InputLabel id="preferredMethodOfContact">Connect PayPal Account</InputLabel>
              <CustomButton $variant="connect" fullWidth>
                Click here to connect
              </CustomButton>
              <Typography fontSize={13} style={{ color: '#c2ccd8', letterSpacing: 1, marginBottom: 15 }}>
                Status: Not Connected
              </Typography>
            </div>
          )}
          <CheckboxContainer item lg={12} md={12} xs={12}>
            <Checkbox label="Make it default payment method" name="default" labelPlacement="end" />
          </CheckboxContainer>
        </Content>
        <ActionsContainer>
          <CustomButton $variant="primary" fullWidth>
            Add
          </CustomButton>
          <CustomButton fullWidth onClick={() => onClose(false)}>
            Cancel
          </CustomButton>
        </ActionsContainer>
      </CustomDialogContent>
    </CustomDialog>
  );
};

export default AddPaymentMethodModal;
